module.exports = __webpack_public_path__ + "img/compressed-2018227890063282176.78e1a249.png";